"use client";

import React, { createRef } from "react";
import { BaseVariableSchema } from "namirasoft-schema";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { NSBoxBuilder } from "../NSBoxBuilder";
import { INSBoxBaseLayoutProps } from "./NSBoxBaseLayout";
import { INSBox } from "./INSBox";
import { NSBox } from "./NSBox";

export interface NSBoxDynamicProps extends IBaseComponentProps, INSBoxBaseLayoutProps<NSBoxDynamic, string>
{
	name: string;
	variable: BaseVariableSchema;
	input?: IBaseComponentProps;
}

export interface NSBoxDynamicState
{ }

export class NSBoxDynamic extends React.Component<NSBoxDynamicProps, NSBoxDynamicState> implements INSBox
{
	private builder: NSBoxBuilder;
	private box_ref = createRef<INSBox>();

	constructor(props: NSBoxDynamicProps)
	{
		super(props);
		this.state = {};
		this.builder = new NSBoxBuilder(this, this.props, this.box_ref, "");
		this.getError = this.getError.bind(this);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
	}
	getError(): string | null
	{
		return this.box_ref.current?.getError() ?? null;
	}
	getValue(checkError: boolean = true): any
	{
		return this.builder.getValue(checkError);
	}
	setValue(value: any | null, callback?: () => void): void
	{
		this.builder.setValue(value, callback);
	}
	isEmpty(value: any)
	{
		return this.box_ref.current?.isEmpty(value) ?? true;
	}
	override render()
	{
		let ans = this.builder.runSynch(() => { });
		if (!ans)
			return <div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					color: "black",
					height: NSBox.height.box,
					width: NSBox.width.one,
					border: "1px solid black",
				}}
			>Not implemented</div>
		return ans;
	}
}